import { WallpaperConfig } from '../config/wallpaper-config';

import request from '@module/http/axios/request';

function createImageTag(src) {
  if (!src) return;

  let img = new Image();
  img.onload = () => {
    img.onload = null;
    img = null;
  };
  img.setAttribute('src', src);
}

function track(customEvents, eventId) {
  const src = customEvents[eventId];
  if (src) createImageTag(src);
}

function trackWalter(customEvent) {
  const payload = {
    sid: String(customEvent?.session?.domainUserId) ?? '',
    cid: String(customEvent?.wallpaper?.creative.id) ?? '',
    cco: String(customEvent?.session?.region?.country) ?? '',
    lng: String(customEvent?.session?.language) ?? '',
    zid: String(customEvent?.zoneId) ?? '',
    ...customEvent.event,
  };
  return request({
    headers: { 'Content-Type': 'application/json' },
    path: WallpaperConfig.walter.api,
    method: 'post',
    params: JSON.stringify(payload),
  });
}

export function getDuid(cookieName) {
  cookieName = cookieName || '_sp_';
  const matcher = new RegExp(cookieName + 'id\\.[a-f0-9]+=([^;]+);?');
  const match = document.cookie.match(matcher);
  if (match && match[1]) {
    return match[1].split('.')[0];
  }
  return '';
}

export const CustomEvents = {
  track,
  trackWalter,
};
